import { Component } from 'react';
import ReactSelect from '../../components/ReactSelect';
import MenuList from '../../components/MenuList';
import { withTranslation } from 'react-i18next';

class SelectComponent extends Component {
    constructor() {
        super();

        this.urlParams = new URLSearchParams(window.location.search);
        this.entity = this.urlParams.get('entity');

        this.state = {
            entity: this.entity ?? '',
        };
    }
    onSelect(value) {
        const a = document.createElement('a');
        a.href = `${window.location.pathname}?entity=${value}`;
        a.target = '_blank';
        a.click();
    }

    render() {
        const { t } = this.props;
        const options = this.props.data?.map((item) => ({ label: item.name, value: item.name }));
        return (
            <div className="entity-select-component">
                <label>{t('discover.entity_clusters.select')}</label>
                <ReactSelect
                    options={options}
                    defaultValue={options.find((x) => x.value === this.state.entity)}
                    value={options.find((x) => x.value === this.state.entity)}
                    onChange={(value) => this.onSelect(value)}
                    blurInputOnSelect={true}
                    classname="mr-10"
                    isSearchable
                    components={{ MenuList }}
                />
            </div>
        );
    }
}

export default withTranslation()(SelectComponent);
